// Careers section content (info pages; applications submit via /careers/apply)

export const careersContent = {
  "careers-home": {
    kicker: "// CAREERS.HOME",
    title: "Build the work you'd stay for.",
    tagline: "Elite operators. Zero politics. Real ownership.",
    intro:
      "TraceElements hires engineers and operators who need momentum. Compensation is transparent, feedback is direct, and the work ships. If you're evaluating firms, the fastest signal is our engagements themselves — read the playbooks, then decide.",
    pillars: [
      { id: "01", label: "HOW.WE.HIRE", body: "Portfolio + take-home + founder-led final. No behavioral theater. We evaluate craft.", bullets: [{ title: "3-step process", desc: "" }, { title: "Founder-final", desc: "" }, { title: "Take-home paid", desc: "" }] },
      { id: "02", label: "COMPENSATION", body: "Transparent global bands. Base + performance bonus + engagement equity on select projects.", bullets: [{ title: "Global bands published", desc: "" }, { title: "Engagement equity", desc: "" }, { title: "Async work stipend", desc: "" }] },
      { id: "03", label: "GROWTH", body: "Vertical slice ownership from day one. Mentorship from founders. Real product exposure.", bullets: [{ title: "Own full slices", desc: "" }, { title: "Ship named work", desc: "" }, { title: "Founder mentorship", desc: "" }] },
    ],
    stats: [{ value: "3", label: "Interview steps" }, { value: "$", label: "Paid take-home" }, { value: "100%", label: "Remote-first" }],
    faqs: [{ q: "Do you sponsor visas?", a: "We are fully remote — visa sponsorship is rarely necessary. We compensate globally, work anywhere with strong internet." }],
    cta: { title: "View open roles.", sub: "See what we're hiring for.", href: "/careers/experienced-hires" },
  },

  "experienced-hires": {
    kicker: "// CAREERS.EXPERIENCED",
    title: "Senior engineers and operators. Direct impact.",
    tagline: "For practitioners with 5+ years of proven output.",
    intro:
      "Experienced hires at TraceElements own significant scope on day one. You will lead vertical engagements, mentor junior pods, and directly influence how the firm operates.",
    pillars: [
      { id: "01", label: "OPEN.ROLES", body: "Senior Full-Stack, AI Systems Engineer, Cloud Architect, Technical PM, Delivery Lead, Cybersecurity Lead.", bullets: [{ title: "6 active tracks", desc: "" }, { title: "Rolling intake", desc: "" }] },
      { id: "02", label: "WHAT.WE.LOOK.FOR", body: "Shipped systems, technical writing, second-order thinking, calm under load.", bullets: [{ title: "Portfolio > resume", desc: "" }, { title: "Writing sample required", desc: "" }] },
      { id: "03", label: "PROCESS", body: "Application → paid take-home → founder final. 10 business days end-to-end.", bullets: [{ title: "10-day cycle", desc: "" }, { title: "Written offer inside 48h", desc: "" }] },
    ],
    stats: [{ value: "10", label: "Days to decision" }, { value: "$", label: "Paid take-home" }],
    faqs: [{ q: "Do you accept referrals?", a: "Yes — alumni-referred candidates receive priority review." }],
    cta: { title: "Apply.", sub: "Submit your track.", href: "/careers/apply" },
  },

  "students-graduates": {
    kicker: "// CAREERS.EARLY",
    title: "Students and new graduates.",
    tagline: "Structured on-ramps into elite engineering practice.",
    intro:
      "We run a small annual cohort for exceptional students and recent graduates. Cohort members work alongside founders on live engagements from day one.",
    pillars: [
      { id: "01", label: "COHORT.MODEL", body: "6-month structured cohort with weekly founder reviews and end-of-program placement.", bullets: [{ title: "6 months", desc: "" }, { title: "Founder-led", desc: "" }] },
      { id: "02", label: "CURRICULUM", body: "Real engagement work + weekly craft sessions + published capstone project.", bullets: [{ title: "Live client work", desc: "" }, { title: "Public capstone", desc: "" }] },
      { id: "03", label: "OUTCOMES", body: "Cohort graduates receive full offers or high-signal recommendations to peer firms.", bullets: [{ title: "80% conversion to FT", desc: "" }] },
    ],
    stats: [{ value: "6mo", label: "Cohort length" }, { value: "80%", label: "FT conversion" }],
    faqs: [],
    cta: { title: "Apply to next cohort.", sub: "Applications open twice yearly.", href: "/careers/apply" },
  },

  "meet-our-people": {
    kicker: "// CAREERS.PEOPLE",
    title: "The operators inside the engine.",
    tagline: "Real people. Real work. Real careers.",
    intro:
      "TraceElements is built by a small, deep team — every member has full context on the firm, real skin in the game, and public output you can trace.",
    pillars: [
      { id: "01", label: "FOUNDERS", body: "Lao Dara (Engineering) and Sherrie Dara (Operations). Founder profiles on /the-engine.", bullets: [] },
      { id: "02", label: "PRINCIPALS", body: "Senior engineers and operators leading verticals: AI, Cloud, Cyber, Delivery.", bullets: [] },
      { id: "03", label: "COHORT", body: "Emerging engineers on the 6-month cohort track.", bullets: [] },
    ],
    stats: [],
    faqs: [],
    cta: { title: "Meet the founders.", sub: "See the operating leadership.", href: "/the-engine" },
  },

  "careers-blog": {
    kicker: "// CAREERS.BLOG",
    title: "TraceElements Careers Blog.",
    tagline: "Field notes on hiring, growing, and shipping.",
    intro:
      "Longer-form pieces from our founders and senior engineers on how we hire, why we structure the firm the way we do, and what we've learned along the way.",
    pillars: [
      { id: "01", label: "HIRING.THEORY", body: "How we evaluate craft over credentials.", bullets: [] },
      { id: "02", label: "FIELD.NOTES", body: "Retrospectives from real engagements.", bullets: [] },
      { id: "03", label: "CULTURE", body: "How we run an async, remote-first firm.", bullets: [] },
    ],
    stats: [],
    faqs: [],
    cta: { title: "Browse all insights.", sub: "Cross-linked with our public research.", href: "/insights" },
  },

  "making-an-impact": {
    kicker: "// CAREERS.IMPACT",
    title: "Every engineer here ships work with a name attached.",
    tagline: "Impact is measurable, public, and portable.",
    intro:
      "At TraceElements you don't disappear into a pool of billable hours. Your work is named, your decisions are archived, and your portfolio grows with every engagement.",
    pillars: [
      { id: "01", label: "NAMED.WORK", body: "Every deliverable carries the engineer's byline in the internal record.", bullets: [] },
      { id: "02", label: "PORTABLE.OUTPUT", body: "You leave with a public case study, playbook, or open-source contribution.", bullets: [] },
      { id: "03", label: "COMPOUND.REPUTATION", body: "Our team members' names appear on the industry's most credible engineering references.", bullets: [] },
    ],
    stats: [{ value: "1", label: "Byline per engagement" }],
    faqs: [],
    cta: { title: "Read the impact reports.", sub: "Public engagement retrospectives.", href: "/insights" },
  },

  "your-well-being": {
    kicker: "// CAREERS.WELLBEING",
    title: "Sustainable pace. Non-negotiable boundaries.",
    tagline: "We do not sell the myth of hustle.",
    intro:
      "TraceElements is designed to be a career-length firm — not a two-year burnout tour. Compensation, boundaries, and time off are all engineered to sustain elite output.",
    pillars: [
      { id: "01", label: "BOUNDARIES", body: "No weekend messages. No 2am escalations. Real off-hours.", bullets: [{ title: "Async by default", desc: "" }, { title: "Zero on-call theater", desc: "" }] },
      { id: "02", label: "TIME.OFF", body: "Minimum 4 weeks paid leave. Firm-wide winter shutdown.", bullets: [{ title: "4wk minimum PTO", desc: "" }, { title: "Firm shutdown Dec 20 – Jan 4", desc: "" }] },
      { id: "03", label: "HEALTH", body: "Global health stipend, mental-health coverage, and annual well-being audit.", bullets: [{ title: "Global stipend", desc: "" }, { title: "Mental health first", desc: "" }] },
    ],
    stats: [{ value: "4wk", label: "Minimum PTO" }, { value: "2wk", label: "Firm shutdown/yr" }],
    faqs: [],
    cta: { title: "Apply.", sub: "Sustainable, elite, remote.", href: "/careers/apply" },
  },
};
